export default __webpack_public_path__ + "static/media/smart-connection-web.478d47f2.svg";